import { usePage, router } from "@inertiajs/react";
import NavigationBar from "../pages/Home/sections/NavigationBar";
import TopRibon from "../pages/Home/sections/TopRibon";
import FooterSection from "../pages/Home/sections/FooterSection";
import ContentSidebar from "../pages/shared/ContentSidebar";
import { useScreenSize } from "../hooks/useScreenSize";
import { ReactNode, useEffect, useRef } from "react";

interface ContentLayoutWrapperProps {
  children: ReactNode;
}

export default function ContentLayoutWrapper({ children }: ContentLayoutWrapperProps) {
  const { navigationData, sidebarData } = usePage<{ navigationData: any; sidebarData: any }>().props;
  const { screenLargerThan } = useScreenSize();
  const isLarge = screenLargerThan('lg');
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // Reset scroll position on navigation
  useEffect(() => {
    const removeListener = router.on('navigate', () => {
      scrollContainerRef.current?.scrollTo(0, 0);
    });
    return removeListener;
  }, []);

  return (
    <div className="h-full flex flex-col">
      <TopRibon topRibbon={navigationData?.top_ribbon} />
      <NavigationBar referencesSections={navigationData?.references_sections} />
      <main className="flex-1 flex overflow-hidden bg-base-100">
        <div ref={scrollContainerRef} id="main-scroll-container" className="flex-1 overflow-y-auto overflow-x-hidden">
          <div style={{
            display: 'flex',
            flexDirection: isLarge ? 'row' : 'column',
            minHeight: '100%',
          }}>
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minWidth: 0,
            }}>
              {children}
            </div>

            <div style={{
              position: isLarge ? 'sticky' : 'relative',
              top: isLarge ? 0 : undefined,
              alignSelf: isLarge ? 'flex-start' : undefined,
              height: isLarge ? 'fit-content' : undefined,
              maxHeight: isLarge ? '100vh' : undefined,
              overflowY: isLarge ? 'auto' : undefined,
            }}>
              <ContentSidebar sidebarData={sidebarData} />
            </div>
          </div>

          <FooterSection
            referencesSections={navigationData?.references_sections}
            topRibbon={navigationData?.top_ribbon}
          />
        </div>
      </main>
    </div>
  );
}
